(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Collection-grid color tiles: the "image" block only knows the product, not the
  // specific variant, so every color tile would otherwise show the same default photo.
  // This swaps in the correct variant photo after render, using data-variant-image
  // (set from Liquid to that variant's own featured image). A MutationObserver handles
  // cards added later via infinite scroll, not just the initial page load.
  function applyVariantImages(root) {
    root.querySelectorAll('product-card[data-variant-image]:not([data-variant-image-applied])').forEach((card) => {
      const url = card.getAttribute('data-variant-image');
      const img = card.querySelector('.product-card__content img');
      if (img && url) {
        img.src = url;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        card.setAttribute('data-variant-image-applied', 'true');
      }
    });
  }

  // Same problem, same fix, for the visible title: the title block only knows the
  // product, not which color tile it's in, so every tile shows the bare product name.
  // This appends "(Color)" onto the heading text using the color value set on the card.
  function applyVariantTitles(root) {
    root.querySelectorAll('product-card[data-variant-color]:not([data-variant-title-applied])').forEach((card) => {
      const color = card.getAttribute('data-variant-color');
      const heading = card.querySelector('.product-card__content [role="heading"][aria-level="3"]');
      if (heading && color) {
        heading.textContent = `${heading.textContent.trim()} (${color})`;
        card.setAttribute('data-variant-title-applied', 'true');
      }
    });
  }

  applyVariantImages(document);
  applyVariantTitles(document);

  const variantImageObserver = new MutationObserver(() => {
    applyVariantImages(document);
    applyVariantTitles(document);
  });
  variantImageObserver.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
